import { render, staticRenderFns } from "./promptCategory.vue?vue&type=template&id=0a25bb8e&scoped=true&"
import script from "./promptCategory.vue?vue&type=script&lang=js&"
export * from "./promptCategory.vue?vue&type=script&lang=js&"
import style0 from "./promptCategory.vue?vue&type=style&index=0&id=0a25bb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a25bb8e",
  null
  
)

export default component.exports